// _*_*_*_*_*_*_*_*_ THIS IS CODE IS JUST TO GET US OVER PHASE 1 _*_*_*_*_*_*_*_*_

if ($('#checkout-content-container').length > 0) {
    
    //Set the site root to detect if the test or live site is being used, this is needed for the AJAX requests. The site root is set here to make it a global variable
    var siteRoot = window.location.protocol + "//" + window.location.host + "/";
    if ((window.location.hostname === "dev.axisfirst.net") || (window.location.hostname === "staging.axisfirst.net")) siteRoot = siteRoot + window.location.pathname.replace(/^\/([^\/]*).*$/, '$1') + "/";
    var siteRootCommon = siteRoot + "template/checkout/";


    //---- jQuery $.browser fix ----
    //$.browser was removed from jQuery in version 1.9.
    //This function adds the $.browser functionality back for the plugins below that still require it.
    var matched, browser;

    jQuery.uaMatch = function (ua) {
    ua = ua.toLowerCase();
    var match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
        /(webkit)[ \/]([\w.]+)/.exec(ua) ||
        /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
        /(msie)[\s?]([\w.]+)/.exec(ua) ||
        /(trident)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
        ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];

    return {
        browser: match[1] || "",
        version: match[2] || "0"
    };
    };
    matched = jQuery.uaMatch(navigator.userAgent);
    //IE 11+ fix (Trident)
    matched.browser = matched.browser == 'trident' ? 'msie' : matched.browser;
    browser = {};

    if (matched.browser) {
    browser[matched.browser] = true;
    browser.version = matched.version;
    }
    //Chrome is Webkit, but Webkit is also Safari.
    if (browser.chrome) {
    browser.webkit = true;
    } else if (browser.webkit) {
    browser.safari = true;
    }

    jQuery.browser = browser;

/**
 * jQuery Validation Plugin 1.8.1
 *
 * http://bassistance.de/jquery-plugins/jquery-plugin-validation/
 * http://docs.jquery.com/Plugins/Validation
 *
 * Copyright (c) 2006 - 2011 Jörn Zaefferer
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 */

 (function($) {

    $.extend($.fn, {
        // http://docs.jquery.com/Plugins/Validation/validate
        validate: function( options ) {
    
            // if nothing is selected, return nothing; can't chain anyway
            if (!this.length) {
                options && options.debug && window.console && console.warn( "nothing selected, can't validate, returning nothing" );
                return;
            }
    
            // check if a validator for this form was already created
            var validator = $.data(this[0], 'validator');
            if ( validator ) {
                return validator;
            }
    
            validator = new $.validator( options, this[0] );
            $.data(this[0], 'validator', validator);
    
            if ( validator.settings.onsubmit ) {
    
                // allow suppresing validation by adding a cancel class to the submit button
                this.find("input, button").filter(".cancel").click(function() {
                    validator.cancelSubmit = true;
                });
    
                // when a submitHandler is used, capture the submitting button
                if (validator.settings.submitHandler) {
                    this.find("input, button").filter(":submit").click(function() {
                        validator.submitButton = this;
                    });
                }
    
                // validate the form on submit
                this.submit( function( event ) {
                    if ( validator.settings.debug )
                        // prevent form submit to be able to see console output
                        event.preventDefault();
    
                    function handle() {
                        if ( validator.settings.submitHandler ) {
                            if (validator.submitButton) {
                                // insert a hidden input as a replacement for the missing submit button
                                var hidden = $("<input type='hidden'/>").attr("name", validator.submitButton.name).val(validator.submitButton.value).appendTo(validator.currentForm);
                            }
                            validator.settings.submitHandler.call( validator, validator.currentForm );
                            if (validator.submitButton) {
                                // and clean up afterwards; thanks to no-block-scope, hidden can be referenced
                                hidden.remove();
                            }
                            return false;
                        }
                        return true;
                    }
    
                    // prevent submit for invalid forms or custom submit handlers
                    if ( validator.cancelSubmit ) {
                        validator.cancelSubmit = false;
                        return handle();
                    }
                    if ( validator.form() ) {
                        if ( validator.pendingRequest ) {
                            validator.formSubmitted = true;
                            return false;
                        }
                        return handle();
                    } else {
                        validator.focusInvalid();
                        return false;
                    }
                });
            }
    
            return validator;
        },
        // http://docs.jquery.com/Plugins/Validation/valid
        valid: function() {
            if ( $(this[0]).is('form')) {
                return this.validate().form();
            } else {
                var valid = true;
                var validator = $(this[0].form).validate();
                this.each(function() {
                    valid &= validator.element(this);
                });
                return valid;
            }
        },
        // attributes: space seperated list of attributes to retrieve and remove
        removeAttrs: function(attributes) {
            var result = {},
                $element = this;
            $.each(attributes.split(/\s/), function(index, value) {
                result[value] = $element.attr(value);
                $element.removeAttr(value);
            });
            return result;
        },
        // http://docs.jquery.com/Plugins/Validation/rules
        rules: function(command, argument) {
            var element = this[0];
    
            if (command) {
                var settings = $.data(element.form, 'validator').settings;
                var staticRules = settings.rules;
                var existingRules = $.validator.staticRules(element);
                switch(command) {
                case "add":
                    $.extend(existingRules, $.validator.normalizeRule(argument));
                    staticRules[element.name] = existingRules;
                    if (argument.messages)
                        settings.messages[element.name] = $.extend( settings.messages[element.name], argument.messages );
                    break;
                case "remove":
                    if (!argument) {
                        delete staticRules[element.name];
                        return existingRules;
                    }
                    var filtered = {};
                    $.each(argument.split(/\s/), function(index, method) {
                        filtered[method] = existingRules[method];
                        delete existingRules[method];
                    });
                    return filtered;
                }
            }
    
            var data = $.validator.normalizeRules(
            $.extend(
                {},
                $.validator.metadataRules(element),
                $.validator.classRules(element),
                $.validator.attributeRules(element),
                $.validator.staticRules(element)
            ), element);
    
            // make sure required is at front
            if (data.required) {
                var param = data.required;
                delete data.required;
                data = $.extend({required: param}, data);
            }
    
            return data;
        }
    });
    
    // Custom selectors
    $.extend($.expr[":"], {
        // http://docs.jquery.com/Plugins/Validation/blank
        blank: function(a) {return !$.trim("" + a.value);},
        // http://docs.jquery.com/Plugins/Validation/filled
        filled: function(a) {return !!$.trim("" + a.value);},
        // http://docs.jquery.com/Plugins/Validation/unchecked
        unchecked: function(a) {return !a.checked;}
    });
    
    // constructor for validator
    $.validator = function( options, form ) {
        this.settings = $.extend( true, {}, $.validator.defaults, options );
        this.currentForm = form;
        this.init();
    };
    
    $.validator.format = function(source, params) {
        if ( arguments.length == 1 )
            return function() {
                var args = $.makeArray(arguments);
                args.unshift(source);
                return $.validator.format.apply( this, args );
            };
        if ( arguments.length > 2 && params.constructor != Array  ) {
            params = $.makeArray(arguments).slice(1);
        }
        if ( params.constructor != Array ) {
            params = [ params ];
        }
        $.each(params, function(i, n) {
            source = source.replace(new RegExp("\\{" + i + "\\}", "g"), n);
        });
        return source;
    };
    
    $.extend($.validator, {
    
        defaults: {
            messages: {},
            groups: {},
            rules: {},
            errorClass: "error",
            validClass: "valid",
            errorElement: "label",
            focusInvalid: true,
            errorContainer: $( [] ),
            errorLabelContainer: $( [] ),
            onsubmit: true,
            ignore: [],
            ignoreTitle: false,
            onfocusin: function(element) {
                this.lastActive = element;
    
                // hide error label and remove error class on focus if enabled
                if ( this.settings.focusCleanup && !this.blockFocusCleanup ) {
                    this.settings.unhighlight && this.settings.unhighlight.call( this, element, this.settings.errorClass, this.settings.validClass );
                    this.addWrapper(this.errorsFor(element)).hide();
                }
            },
            onfocusout: function(element) {
                if ( !this.checkable(element) && (element.name in this.submitted || !this.optional(element)) ) {
                    this.element(element);
                }
            },
            onkeyup: function(element) {
                if ( element.name in this.submitted || element == this.lastElement ) {
                    this.element(element);
                }
            },
            onclick: function(element) {
                // click on selects, radiobuttons and checkboxes
                if ( element.name in this.submitted )
                    this.element(element);
                // or option elements, check parent select in that case
                else if (element.parentNode.name in this.submitted)
                    this.element(element.parentNode);
            },
            highlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).addClass(errorClass).removeClass(validClass);
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).removeClass(errorClass).addClass(validClass);
                } else {
                    $(element).removeClass(errorClass).addClass(validClass);
                }
            }
        },
    
        // http://docs.jquery.com/Plugins/Validation/Validator/setDefaults
        setDefaults: function(settings) {
            $.extend( $.validator.defaults, settings );
        },
    
        messages: {
            required: "This field is required.",
            remote: "Please fix this field.",
            email: "Please enter a valid email address.",
            url: "Please enter a valid URL.",
            date: "Please enter a valid date.",
            dateISO: "Please enter a valid date (ISO).",
            number: "Please enter a valid number.",
            digits: "Please enter only digits.",
            creditcard: "Please enter a valid credit card number.",
            equalTo: "Please enter the same value again.",
            accept: "Please enter a value with a valid extension.",
            maxlength: $.validator.format("Please enter no more than {0} characters."),
            minlength: $.validator.format("Please enter at least {0} characters."),
            rangelength: $.validator.format("Please enter a value between {0} and {1} characters long."),
            range: $.validator.format("Please enter a value between {0} and {1}."),
            max: $.validator.format("Please enter a value less than or equal to {0}."),
            min: $.validator.format("Please enter a value greater than or equal to {0}.")
        },
    
        autoCreateRanges: false,
    
        prototype: {
    
            init: function() {
                this.labelContainer = $(this.settings.errorLabelContainer);
                this.errorContext = this.labelContainer.length && this.labelContainer || $(this.currentForm);
                this.containers = $(this.settings.errorContainer).add( this.settings.errorLabelContainer );
                this.submitted = {};
                this.valueCache = {};
                this.pendingRequest = 0;
                this.pending = {};
                this.invalid = {};
                this.reset();
    
                var groups = (this.groups = {});
                $.each(this.settings.groups, function(key, value) {
                    $.each(value.split(/\s/), function(index, name) {
                        groups[name] = key;
                    });
                });
                var rules = this.settings.rules;
                $.each(rules, function(key, value) {
                    rules[key] = $.validator.normalizeRule(value);
                });
    
                function delegate(event) {
                    var validator = $.data(this[0].form, "validator"),
                        eventType = "on" + event.type.replace(/^validate/, "");
                    validator.settings[eventType] && validator.settings[eventType].call(validator, this[0] );
                }
                $(this.currentForm)
                    .validateDelegate(":text, :password, :file, select, textarea", "focusin focusout keyup", delegate)
                    .validateDelegate(":radio, :checkbox, select, option", "click", delegate);
    
                if (this.settings.invalidHandler)
                    $(this.currentForm).bind("invalid-form.validate", this.settings.invalidHandler);
            },
    
            // http://docs.jquery.com/Plugins/Validation/Validator/form
            form: function() {
                this.checkForm();
                $.extend(this.submitted, this.errorMap);
                this.invalid = $.extend({}, this.errorMap);
                if (!this.valid())
                    $(this.currentForm).triggerHandler("invalid-form", [this]);
                this.showErrors();
                return this.valid();
            },
    
            checkForm: function() {
                this.prepareForm();
                for ( var i = 0, elements = (this.currentElements = this.elements()); elements[i]; i++ ) {
                    this.check( elements[i] );
                }
                return this.valid();
            },
    
            // http://docs.jquery.com/Plugins/Validation/Validator/element
            element: function( element ) {
                element = this.clean( element );
                this.lastElement = element;
                this.prepareElement( element );
                this.currentElements = $(element);
                var result = this.check( element );
                if ( result ) {
                    delete this.invalid[element.name];
                } else {
                    this.invalid[element.name] = true;
                }
                if ( !this.numberOfInvalids() ) {
                    // Hide error containers on last error
                    this.toHide = this.toHide.add( this.containers );
                }
                this.showErrors();
                return result;
            },
    
            // http://docs.jquery.com/Plugins/Validation/Validator/showErrors
            showErrors: function(errors) {
                if(errors) {
                    // add items to error list and map
                    $.extend( this.errorMap, errors );
                    this.errorList = [];
                    for ( var name in errors ) {
                        this.errorList.push({
                            message: errors[name],
                            element: this.findByName(name)[0]
                        });
                    }
                    // remove items from success list
                    this.successList = $.grep( this.successList, function(element) {
                        return !(element.name in errors);
                    });
                }
                this.settings.showErrors
                    ? this.settings.showErrors.call( this, this.errorMap, this.errorList )
                    : this.defaultShowErrors();
            },
    
            // http://docs.jquery.com/Plugins/Validation/Validator/resetForm
            resetForm: function() {
                if ( $.fn.resetForm )
                    $( this.currentForm ).resetForm();
                this.submitted = {};
                this.prepareForm();
                this.hideErrors();
                this.elements().removeClass( this.settings.errorClass );
            },
    
            numberOfInvalids: function() {
                return this.objectLength(this.invalid);
            },
    
            objectLength: function( obj ) {
                var count = 0;
                for ( var i in obj )
                    count++;
                return count;
            },
    
            hideErrors: function() {
                this.addWrapper( this.toHide ).hide();
            },
    
            valid: function() {
                return this.size() == 0;
            },
    
            size: function() {
                return this.errorList.length;
            },
    
            focusInvalid: function() {
                if( this.settings.focusInvalid ) {
                    try {
                        $(this.findLastActive() || this.errorList.length && this.errorList[0].element || [])
                        .filter(":visible")
                        .focus()
                        // manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
                        .trigger("focusin");
                    } catch(e) {
                        // ignore IE throwing errors when focusing hidden elements
                    }
                }
            },
    
            findLastActive: function() {
                var lastActive = this.lastActive;
                return lastActive && $.grep(this.errorList, function(n) {
                    return n.element.name == lastActive.name;
                }).length == 1 && lastActive;
            },
    
            elements: function() {
                var validator = this,
                    rulesCache = {};
    
                // select all valid inputs inside the form (no submit or reset buttons)
                return $(this.currentForm)
                .find("input, select, textarea")
                .not(":submit, :reset, :image, [disabled]")
                .not( this.settings.ignore )
                .filter(function() {
                    !this.name && validator.settings.debug && window.console && console.error( "%o has no name assigned", this);
    
                    // select only the first element for each name, and only those with rules specified
                    if ( this.name in rulesCache || !validator.objectLength($(this).rules()) )
                        return false;
    
                    rulesCache[this.name] = true;
                    return true;
                });
            },
    
            clean: function( selector ) {
                return $( selector )[0];
            },
    
            errors: function() {
                return $( this.settings.errorElement + "." + this.settings.errorClass, this.errorContext );
            },
    
            reset: function() {
                this.successList = [];
                this.errorList = [];
                this.errorMap = {};
                this.toShow = $([]);
                this.toHide = $([]);
                this.currentElements = $([]);
            },
    
            prepareForm: function() {
                this.reset();
                this.toHide = this.errors().add( this.containers );
            },
    
            prepareElement: function( element ) {
                this.reset();
                this.toHide = this.errorsFor(element);
            },
    
            check: function( element ) {
                element = this.clean( element );
    
                // if radio/checkbox, validate first element in group instead
                if (this.checkable(element)) {
                    element = this.findByName( element.name ).not(this.settings.ignore)[0];
                }
    
                var rules = $(element).rules();
                var dependencyMismatch = false;
                for (var method in rules ) {
                    var rule = { method: method, parameters: rules[method] };
                    try {
                        var result = $.validator.methods[method].call( this, element.value.replace(/\r/g, ""), element, rule.parameters );
    
                        // if a method indicates that the field is optional and therefore valid,
                        // don't mark it as valid when there are no other rules
                        if ( result == "dependency-mismatch" ) {
                            dependencyMismatch = true;
                            continue;
                        }
                        dependencyMismatch = false;
    
                        if ( result == "pending" ) {
                            this.toHide = this.toHide.not( this.errorsFor(element) );
                            return;
                        }
    
                        if( !result ) {
                            this.formatAndAdd( element, rule );
                            return false;
                        }
                    } catch(e) {
                        this.settings.debug && window.console && console.log("exception occured when checking element " + element.id
                             + ", check the '" + rule.method + "' method", e);
                        throw e;
                    }
                }
                if (dependencyMismatch)
                    return;
                if ( this.objectLength(rules) )
                    this.successList.push(element);
                return true;
            },
    
            // return the custom message for the given element and validation method
            // specified in the element's "messages" metadata
            customMetaMessage: function(element, method) {
                if (!$.metadata)
                    return;
    
                var meta = this.settings.meta
                    ? $(element).metadata()[this.settings.meta]
                    : $(element).metadata();
    
                return meta && meta.messages && meta.messages[method];
            },
    
            // return the custom message for the given element name and validation method
            customMessage: function( name, method ) {
                var m = this.settings.messages[name];
                return m && (m.constructor == String
                    ? m
                    : m[method]);
            },
    
            // return the first defined argument, allowing empty strings
            findDefined: function() {
                for(var i = 0; i < arguments.length; i++) {
                    if (arguments[i] !== undefined)
                        return arguments[i];
                }
                return undefined;
            },
    
            defaultMessage: function( element, method) {
                return this.findDefined(
                    this.customMessage( element.name, method ),
                    this.customMetaMessage( element, method ),
                    // title is never undefined, so handle empty string as undefined
                    !this.settings.ignoreTitle && element.title || undefined,
                    $.validator.messages[method],
                    "<strong>Warning: No message defined for " + element.name + "</strong>"
                );
            },
    
            formatAndAdd: function( element, rule ) {
                var message = this.defaultMessage( element, rule.method ),
                    theregex = /\$?\{(\d+)\}/g;
                if ( typeof message == "function" ) {
                    message = message.call(this, rule.parameters, element);
                } else if (theregex.test(message)) {
                    message = jQuery.format(message.replace(theregex, '{$1}'), rule.parameters);
                }
                this.errorList.push({
                    message: message,
                    element: element
                });
    
                this.errorMap[element.name] = message;
                this.submitted[element.name] = message;
            },
    
            addWrapper: function(toToggle) {
                if ( this.settings.wrapper )
                    toToggle = toToggle.add( toToggle.parent( this.settings.wrapper ) );
                return toToggle;
            },
    
            defaultShowErrors: function() {
                for ( var i = 0; this.errorList[i]; i++ ) {
                    var error = this.errorList[i];
                    this.settings.highlight && this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
                    this.showLabel( error.element, error.message );
                }
                if( this.errorList.length ) {
                    this.toShow = this.toShow.add( this.containers );
                }
                if (this.settings.success) {
                    for ( var i = 0; this.successList[i]; i++ ) {
                        this.showLabel( this.successList[i] );
                    }
                }
                if (this.settings.unhighlight) {
                    for ( var i = 0, elements = this.validElements(); elements[i]; i++ ) {
                        this.settings.unhighlight.call( this, elements[i], this.settings.errorClass, this.settings.validClass );
                    }
                }
                this.toHide = this.toHide.not( this.toShow );
                this.hideErrors();
                this.addWrapper( this.toShow ).show();
            },
    
            validElements: function() {
                return this.currentElements.not(this.invalidElements());
            },
    
            invalidElements: function() {
                return $(this.errorList).map(function() {
                    return this.element;
                });
            },
    
            showLabel: function(element, message) {
                var label = this.errorsFor( element );
                if ( label.length ) {
                    // refresh error/success class
                    label.removeClass().addClass( this.settings.errorClass );
    
                    // check if we have a generated label, replace the message then
                    label.attr("generated") && label.html(message);
                } else {
                    // create label
                    label = $("<" + this.settings.errorElement + "/>")
                        .attr({"for":  this.idOrName(element), generated: true})
                        .addClass(this.settings.errorClass)
                        .html(message || "");
                    if ( this.settings.wrapper ) {
                        // make sure the element is visible, even in IE
                        // actually showing the wrapped element is handled elsewhere
                        label = label.hide().show().wrap("<" + this.settings.wrapper + "/>").parent();
                    }
                    if ( !this.labelContainer.append(label).length )
                        this.settings.errorPlacement
                            ? this.settings.errorPlacement(label, $(element) )
                            : label.insertAfter(element);
                }
                if ( !message && this.settings.success ) {
                    label.text("");
                    typeof this.settings.success == "string"
                        ? label.addClass( this.settings.success )
                        : this.settings.success( label );
                }
                this.toShow = this.toShow.add(label);
            },
    
            errorsFor: function(element) {
                var name = this.idOrName(element);
                return this.errors().filter(function() {
                    return $(this).attr('for') == name;
                });
            },
    
            idOrName: function(element) {
                return this.groups[element.name] || (this.checkable(element) ? element.name : element.id || element.name);
            },
    
            checkable: function( element ) {
                return /radio|checkbox/i.test(element.type);
            },
    
            findByName: function( name ) {
                // select by name and filter by form for performance over form.find("[name=...]")
                var form = this.currentForm;
                return $(document.getElementsByName(name)).map(function(index, element) {
                    return element.form == form && element.name == name && element  || null;
                });
            },
    
            getLength: function(value, element) {
                switch( element.nodeName.toLowerCase() ) {
                case 'select':
                    return $("option:selected", element).length;
                case 'input':
                    if( this.checkable( element) )
                        return this.findByName(element.name).filter(':checked').length;
                }
                return value.length;
            },
    
            depend: function(param, element) {
                return this.dependTypes[typeof param]
                    ? this.dependTypes[typeof param](param, element)
                    : true;
            },
    
            dependTypes: {
                "boolean": function(param, element) {
                    return param;
                },
                "string": function(param, element) {
                    return !!$(param, element.form).length;
                },
                "function": function(param, element) {
                    return param(element);
                }
            },
    
            optional: function(element) {
                return !$.validator.methods.required.call(this, $.trim(element.value), element) && "dependency-mismatch";
            },
    
            startRequest: function(element) {
                if (!this.pending[element.name]) {
                    this.pendingRequest++;
                    this.pending[element.name] = true;
                }
            },
    
            stopRequest: function(element, valid) {
                this.pendingRequest--;
                // sometimes synchronization fails, make sure pendingRequest is never < 0
                if (this.pendingRequest < 0)
                    this.pendingRequest = 0;
                delete this.pending[element.name];
                if ( valid && this.pendingRequest == 0 && this.formSubmitted && this.form() ) {
                    $(this.currentForm).submit();
                    this.formSubmitted = false;
                } else if (!valid && this.pendingRequest == 0 && this.formSubmitted) {
                    $(this.currentForm).triggerHandler("invalid-form", [this]);
                    this.formSubmitted = false;
                }
            },
    
            previousValue: function(element) {
                return $.data(element, "previousValue") || $.data(element, "previousValue", {
                    old: null,
                    valid: true,
                    message: this.defaultMessage( element, "remote" )
                });
            }
    
        },
    
        classRuleSettings: {
            required: {required: true},
            email: {email: true},
            url: {url: true},
            date: {date: true},
            dateISO: {dateISO: true},
            dateDE: {dateDE: true},
            number: {number: true},
            numberDE: {numberDE: true},
            digits: {digits: true},
            creditcard: {creditcard: true}
        },
    
        addClassRules: function(className, rules) {
            className.constructor == String ?
                this.classRuleSettings[className] = rules :
                $.extend(this.classRuleSettings, className);
        },
    
        classRules: function(element) {
            var rules = {};
            var classes = $(element).attr('class');
            classes && $.each(classes.split(' '), function() {
                if (this in $.validator.classRuleSettings) {
                    $.extend(rules, $.validator.classRuleSettings[this]);
                }
            });
            return rules;
        },
    
        attributeRules: function(element) {
            var rules = {};
            var $element = $(element);
    
            for (var method in $.validator.methods) {
                var value = $element.attr(method);
                if (value) {
                    rules[method] = value;
                }
            }
    
            // maxlength may be returned as -1, 2147483647 (IE) and 524288 (safari) for text inputs
            if (rules.maxlength && /-1|2147483647|524288/.test(rules.maxlength)) {
                delete rules.maxlength;
            }
    
            return rules;
        },
    
        metadataRules: function(element) {
            if (!$.metadata) return {};
    
            var meta = $.data(element.form, 'validator').settings.meta;
            return meta ?
                $(element).metadata()[meta] :
                $(element).metadata();
        },
    
        staticRules: function(element) {
            var rules = {};
            var validator = $.data(element.form, 'validator');
            if (validator.settings.rules) {
                rules = $.validator.normalizeRule(validator.settings.rules[element.name]) || {};
            }
            return rules;
        },
    
        normalizeRules: function(rules, element) {
            // handle dependency check
            $.each(rules, function(prop, val) {
                // ignore rule when param is explicitly false, eg. required:false
                if (val === false) {
                    delete rules[prop];
                    return;
                }
                if (val.param || val.depends) {
                    var keepRule = true;
                    switch (typeof val.depends) {
                        case "string":
                            keepRule = !!$(val.depends, element.form).length;
                            break;
                        case "function":
                            keepRule = val.depends.call(element, element);
                            break;
                    }
                    if (keepRule) {
                        rules[prop] = val.param !== undefined ? val.param : true;
                    } else {
                        delete rules[prop];
                    }
                }
            });
    
            // evaluate parameters
            $.each(rules, function(rule, parameter) {
                rules[rule] = $.isFunction(parameter) ? parameter(element) : parameter;
            });
    
            // clean number parameters
            $.each(['minlength', 'maxlength', 'min', 'max'], function() {
                if (rules[this]) {
                    rules[this] = Number(rules[this]);
                }
            });
            $.each(['rangelength', 'range'], function() {
                if (rules[this]) {
                    rules[this] = [Number(rules[this][0]), Number(rules[this][1])];
                }
            });
    
            if ($.validator.autoCreateRanges) {
                // auto-create ranges
                if (rules.min && rules.max) {
                    rules.range = [rules.min, rules.max];
                    delete rules.min;
                    delete rules.max;
                }
                if (rules.minlength && rules.maxlength) {
                    rules.rangelength = [rules.minlength, rules.maxlength];
                    delete rules.minlength;
                    delete rules.maxlength;
                }
            }
    
            // To support custom messages in metadata ignore rule methods titled "messages"
            if (rules.messages) {
                delete rules.messages;
            }
    
            return rules;
        },
    
        // Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
        normalizeRule: function(data) {
            if( typeof data == "string" ) {
                var transformed = {};
                $.each(data.split(/\s/), function() {
                    transformed[this] = true;
                });
                data = transformed;
            }
            return data;
        },
    
        // http://docs.jquery.com/Plugins/Validation/Validator/addMethod
        addMethod: function(name, method, message) {
            $.validator.methods[name] = method;
            $.validator.messages[name] = message != undefined ? message : $.validator.messages[name];
            if (method.length < 3) {
                $.validator.addClassRules(name, $.validator.normalizeRule(name));
            }
        },
    
        methods: {
    
            // http://docs.jquery.com/Plugins/Validation/Methods/required
            required: function(value, element, param) {
                // check if dependency is met
                if ( !this.depend(param, element) )
                    return "dependency-mismatch";
                switch( element.nodeName.toLowerCase() ) {
                case 'select':
                    // could be an array for select-multiple or a string, both are fine this way
                    var val = $(element).val();
                    return val && val.length > 0;
                case 'input':
                    if ( this.checkable(element) )
                        return this.getLength(value, element) > 0;
                default:
                    return $.trim(value).length > 0;
                }
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/remote
            remote: function(value, element, param) {
                if ( this.optional(element) )
                    return "dependency-mismatch";
    
                var previous = this.previousValue(element);
                if (!this.settings.messages[element.name] )
                    this.settings.messages[element.name] = {};
                previous.originalMessage = this.settings.messages[element.name].remote;
                this.settings.messages[element.name].remote = previous.message;
    
                param = typeof param == "string" && {url:param} || param;
    
                if ( this.pending[element.name] ) {
                    return "pending";
                }
                if ( previous.old === value ) {
                    return previous.valid;
                }
    
                previous.old = value;
                var validator = this;
                this.startRequest(element);
                var data = {};
                data[element.name] = value;
                $.ajax($.extend(true, {
                    url: param,
                    mode: "abort",
                    port: "validate" + element.name,
                    dataType: "json",
                    data: data,
                    success: function(response) {
                        validator.settings.messages[element.name].remote = previous.originalMessage;
                        var valid = response === true;
                        if ( valid ) {
                            var submitted = validator.formSubmitted;
                            validator.prepareElement(element);
                            validator.formSubmitted = submitted;
                            validator.successList.push(element);
                            validator.showErrors();
                        } else {
                            var errors = {};
                            var message = response || validator.defaultMessage( element, "remote" );
                            errors[element.name] = previous.message = $.isFunction(message) ? message(value) : message;
                            validator.showErrors(errors);
                        }
                        previous.valid = valid;
                        validator.stopRequest(element, valid);
                    }
                }, param));
                return "pending";
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/minlength
            minlength: function(value, element, param) {
                return this.optional(element) || this.getLength($.trim(value), element) >= param;
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/maxlength
            maxlength: function(value, element, param) {
                return this.optional(element) || this.getLength($.trim(value), element) <= param;
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/rangelength
            rangelength: function(value, element, param) {
                var length = this.getLength($.trim(value), element);
                return this.optional(element) || ( length >= param[0] && length <= param[1] );
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/min
            min: function( value, element, param ) {
                return this.optional(element) || value >= param;
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/max
            max: function( value, element, param ) {
                return this.optional(element) || value <= param;
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/range
            range: function( value, element, param ) {
                return this.optional(element) || ( value >= param[0] && value <= param[1] );
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/email
            email: function(value, element) {
                // contributed by Scott Gonzalez: http://projects.scottsplayground.com/email_address_validation/
                return this.optional(element) || /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/url
            url: function(value, element) {
                // contributed by Scott Gonzalez: http://projects.scottsplayground.com/iri/
                return this.optional(element) || /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/date
            date: function(value, element) {
                return this.optional(element) || !/Invalid|NaN/.test(new Date(value));
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/dateISO
            dateISO: function(value, element) {
                return this.optional(element) || /^\d{4}[\/-]\d{1,2}[\/-]\d{1,2}$/.test(value);
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/number
            number: function(value, element) {
                return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(value);
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/digits
            digits: function(value, element) {
                return this.optional(element) || /^\d+$/.test(value);
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/creditcard
            // based on http://en.wikipedia.org/wiki/Luhn
            creditcard: function(value, element) {
                if ( this.optional(element) )
                    return "dependency-mismatch";
                // accept only digits and dashes
                if (/[^0-9-]+/.test(value))
                    return false;
                var nCheck = 0,
                    nDigit = 0,
                    bEven = false;
    
                value = value.replace(/\D/g, "");
    
                for (var n = value.length - 1; n >= 0; n--) {
                    var cDigit = value.charAt(n);
                    var nDigit = parseInt(cDigit, 10);
                    if (bEven) {
                        if ((nDigit *= 2) > 9)
                            nDigit -= 9;
                    }
                    nCheck += nDigit;
                    bEven = !bEven;
                }
    
                return (nCheck % 10) == 0;
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/accept
            accept: function(value, element, param) {
                param = typeof param == "string" ? param.replace(/,/g, '|') : "png|jpe?g|gif";
                return this.optional(element) || value.match(new RegExp(".(" + param + ")$", "i"));
            },
    
            // http://docs.jquery.com/Plugins/Validation/Methods/equalTo
            equalTo: function(value, element, param) {
                // bind to the blur event of the target in order to revalidate whenever the target field is updated
                // TODO find a way to bind the event just once, avoiding the unbind-rebind overhead
                var target = $(param).unbind(".validate-equalTo").bind("blur.validate-equalTo", function() {
                    $(element).valid();
                });
                return value == target.val();
            }
    
        }
    
    });
    
    // deprecated, use $.validator.format instead
    $.format = $.validator.format;
    
    })(jQuery);
    
    // ajax mode: abort
    // usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
    // if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()
    ;(function($) {
        var pendingRequests = {};
        // Use a prefilter if available (1.5+)
        if ( $.ajaxPrefilter ) {
            $.ajaxPrefilter(function(settings, _, xhr) {
                var port = settings.port;
                if (settings.mode == "abort") {
                    if ( pendingRequests[port] ) {
                        pendingRequests[port].abort();
                    }
                    pendingRequests[port] = xhr;
                }
            });
        } else {
            // Proxy ajax
            var ajax = $.ajax;
            $.ajax = function(settings) {
                var mode = ( "mode" in settings ? settings : $.ajaxSettings ).mode,
                    port = ( "port" in settings ? settings : $.ajaxSettings ).port;
                if (mode == "abort") {
                    if ( pendingRequests[port] ) {
                        pendingRequests[port].abort();
                    }
                    return (pendingRequests[port] = ajax.apply(this, arguments));
                }
                return ajax.apply(this, arguments);
            };
        }
    })(jQuery);
    
    // provides cross-browser focusin and focusout events
    // IE has native support, in other browsers, use event caputuring (neither bubbles)
    
    // provides delegate(type: String, delegate: Selector, handler: Callback) plugin for easier event delegation
    // handler is only called when $(event.target).is(delegate), in the scope of the jquery-object for event.target
    ;(function($) {
        // only implement if not provided by jQuery core (since 1.4)
        // TODO verify if jQuery 1.4's implementation is compatible with older jQuery special-event APIs
        if (!jQuery.event.special.focusin && !jQuery.event.special.focusout && document.addEventListener) {
            $.each({
                focus: 'focusin',
                blur: 'focusout'
            }, function( original, fix ){
                $.event.special[fix] = {
                    setup:function() {
                        this.addEventListener( original, handler, true );
                    },
                    teardown:function() {
                        this.removeEventListener( original, handler, true );
                    },
                    handler: function(e) {
                        arguments[0] = $.event.fix(e);
                        arguments[0].type = fix;
                        return $.event.handle.apply(this, arguments);
                    }
                };
                function handler(e) {
                    e = $.event.fix(e);
                    e.type = fix;
                    return $.event.handle.call(this, e);
                }
            });
        };
        $.extend($.fn, {
            validateDelegate: function(delegate, type, handler) {
                return this.bind(type, function(event) {
                    var target = $(event.target);
                    if (target.is(delegate)) {
                        return handler.apply(target, arguments);
                    }
                });
            }
        });
    })(jQuery);
    
    /*Invokes the jQuery validation plugin on the specified forms and sets the validation criteria*/
    //Apply a custom class to the incorrect fields to highlight when they require attension
    $.validator.setDefaults({
        errorClass: "validationError",
        validClass: "validationValid",
        highlight: function(input) {
            $(input).addClass("validationInvalidInput");
        },
        unhighlight: function(input) {
            $(input).removeClass("validationInvalidInput");
        }
    });

    $(document).ready(function(){	/*The change details forms*/
        



    });






    /*******************************************Hidden area toggles******************************************/
    /********************************************************************************************************/
    //To make sure that the plugin doesn't collide with other libraries that might use the dollar sign, it's best practice to pass jQuery to a self executing function ((function($){})(jQuery);) that maps it to the dollar sign so it can't be overwritten by another library in the scope of its execution 
    (function($) {
        //Set the default options for the plugin, this can be overriden when calling the object (i.e. $(".popupLink").popup({"popupContainerID" : "#anotherContainer"});
        $.hiddenAreas = {
            options: {
                targetContainer: "",
                action: "",
                callback: function() {}
            }
        };
    
        //The methods available to this object
        var methods = {
            //This method is run when no methods are specified
            init : function(options, callback) { 
                //For each element found
                return this.each(function(){					  
                    //Using extend allows for the default options to be overridden by any arguments
                    options = $.extend($.hiddenAreas.options, options);
                    var $this = $(this);
                    var data = $this.data("hiddenAreas");
                    //If the plugin hasn't been initialized yet
                    if (!data) {
                        //Set the options for the element
                        $this.data("hiddenAreas", {
                            targetContainer: options.targetContainer,	   
                            action: options.action,
                            callback: options.callback
                        });
                        
                        //If a custom target container has not been specified, set the target to be the id of the clicked element with "Container" appended to it
                        if ($this.data("hiddenAreas").targetContainer === "") {
                            $this.data("hiddenAreas").targetContainer = "#" + $this.attr("id") + "Container";
                        } else if ($this.data("hiddenAreas").targetContainer === "next") {
                            $this.data("hiddenAreas").targetContainer = $this.next();
                        }
                        
                        //If the checkbox is not checked or the click element has the class "closed"
                        if (($this.is("input:checkbox") && !$this.is(":checked")) || ($this.hasClass("closed"))) {
                            //Hide the container by default. This is hidden using JavaScript to enable users with JavaScript disabled to see the container
                            $($this.data("hiddenAreas").targetContainer).hide();
                            //If this is not a checkbox, add the "closed" class
                            if (!$this.is("input:checkbox")) {
                                $this.addClass("closed");
                            }
                        //If the checkbox is checked or the click element does not have the class "closed"
                        } else {
                            //Show it. This is required for when a user shows a hidden area, goes to the next screen then hits the back button
                            $($this.data("hiddenAreas").targetContainer).show();
                        }
                    }
                    
                    //When the elements which involked the jQuery object is clicked on
                    $this.click(function() {
                        //If the checkbox is checked or the click element has the class "closed"
                        if (($this.is("input:checkbox") && $this.is(":checked")) || ($this.hasClass("closed"))) {
                            //Show the container
                            $($this.data("hiddenAreas").targetContainer).slideDown();
                            //If this is not a checkbox, remove the "closed" class
                            if (!$this.is("input:checkbox")) {
                                $this.removeClass("closed");
                            }
                            //If the "scroll" action has been specified for this checkbox
                            if ($this.data("hiddenAreas").action === "scroll") {
                                //Position the associated container at the top of the screen
                                $("html, body").animate({scrollTop: $($this.data("hiddenAreas").targetContainer).offset().top}, 400);
                            }
                        } else { 
                            //Hide the container
                            $($this.data("hiddenAreas").targetContainer).slideUp();
                            //If this is not a checkbox, add the "closed" class
                            if (!$this.is("input:checkbox")) {
                                $this.addClass("closed");
                            }
                        }
                    }); 
                    //Call the callback function
                    if (typeof $this.data("hiddenAreas").callback == 'function') $this.data("hiddenAreas").callback.call(this);
                });	
             }
        };
    
        //Method calling logic
        $.fn.hiddenAreas = function(method) {
            //If a method was specified
            if (methods[method]) {
                //Return the method
                return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
            //If a method was not specified
            } else if (typeof method === "object" || !method) {
                //Return the init method
                return methods.init.apply(this, arguments);
            //If a method that does not exist was specified
            } else {
                //Write the error to the error log
                $.error("Method '" + method + "' does not exist on hiddenAreas");
            }    
        };
    })(jQuery);


    /********************************************************************************************************/
/*************************************************Popups*************************************************/
/********************************************************************************************************/
//To make sure that the plugin doesn't collide with other libraries that might use the dollar sign, it's best practice to pass jQuery to a self executing function ((function($){})(jQuery);) that maps it to the dollar sign so it can't be overwritten by another library in the scope of its execution 
(function($) {
	//Set the default options for the plugin, this can be overriden when calling the object (i.e. $(".popupLink").popup({"popupContainerID" : "#anotherContainer"});
	$.popup = {
		options: {
			buildCallback: function() {},
			closeButtonContent: "",
			closeButtonHide: false,
			closeCallback: function() {},
			closeElements: ".popupCloseButton",
			content: "popups",
			includeURL: siteRootCommon + "template/checkout/includes/getSetContent.asp",
			instantShow: false,
			operation: "get",
			overlayID: "popupOverlay",
			overridePopupID: "",
			parameters: {},
			popupContainerClass: "standard",
			popupContainerID: "popupContainer",
			popupContent: "",
			showCallback: function() {}
    	}
	};

	//The methods available to this object
	var methods = {
		//This method is run when no methods are specified
		init : function(options, callback) { 
			//For each element found
			return this.each(function(){					  
				//Using extend allows for the default options to be overridden by any arguments
				options = $.extend($.popup.options, options);
				var $this = $(this);
				var data = $this.data("popup");
				//If the plugin hasn't been initialized yet
				if (!data) {
					//Set the options for the element
					$this.data("popup", {
						buildCallback: options.buildCallback,
						closeButtonContent: options.closeButtonContent,
						closeButtonHide: options.closeButtonHide,
						closeCallback: options.closeCallback,
						closeElements: options.closeElements,
						content: options.content,
						includeURL: options.includeURL,
						instantShow: options.instantShow,
						operation: options.operation,
						overlayID: options.overlayID,
						overridePopupID: options.overridePopupID,
						parameters: options.parameters,
						popupContainerClass: options.popupContainerClass,
						popupContainerID: options.popupContainerID,
						popupContent: options.popupContent,
						showCallback: options.showCallback
					});
				}
				
				//When the elements which involked the jQuery object is clicked on
				function showPopup() {
					var queryString = "content=" + options.content + "&operation=" + options.operation + "&ajax=true";
					var parameters = $.param(options.parameters);
					if (parameters !== "") queryString = queryString + "&" + parameters
					if (options.content === "popups") {
						//Get the href value of the element clicked, if it exists extract the querystring so the parameters can be passed to the popup
						var linkDestination = $this.attr("href");	
						var linkName = $this.attr("name");
						if ($this.data("popup").overridePopupID !== "") linkName = $this.data("popup").overridePopupID
						queryString = queryString + "&popupID=" + linkName + "&ajax=true"
						if (linkDestination !== "" && typeof linkDestination !== "undefined") {
							var linkQueryStringPosition = linkDestination.indexOf("?"); 
							queryString = queryString + "&" + linkDestination.substring(linkQueryStringPosition + 1);
						}
					}
					
					var popupContent = $this.data("popup").popupContent;
					if (popupContent === "") {
						//Call the popup include page to get the selected popup and display it
						var popupAJAX = $.ajax({ type: "GET", data: queryString, url: $this.data("popup").includeURL, cache: false, success: function(popupContent, status, request){
							var redirect = request.getResponseHeader("axis-redirect");
							if (redirect) {
								window.location = redirect; 
							} else {
								buildPopup(popupContent);
							}
						}}); 
					} else {
						buildPopup(popupContent);
					}
				
					//Call the callback function
					if (typeof $this.data("popup").showCallback == 'function') $this.data("popup").showCallback.call(this);
					
					//When the popup close button is clicked
					$("body").on("click", $this.data("popup").closeElements, function(){
						//Set the elements which are removed on closing
						var $popupElements = $("#" + $this.data("popup").overlayID);
						//Fade out the overlay and popup then remove them
						$popupElements.fadeOut("slow", function(){$popupElements.remove();});
					
						//Call the callback function
						if (typeof $this.data("popup").closeCallback == 'function') {
							$this.data("popup").closeCallback.call(this);
						}
						$($this.data("popup").closeElements).off();
						//Return false to stop the link from following the destination URL
						return false;
					});
				} 
				
				//Build and append the popup
				function buildPopup(popupContent) {
					var popupTemplate = "<div id='" + $this.data("popup").overlayID + "'>" +
										"<div class='" + $this.data("popup").popupContainerClass + "' id='" + $this.data("popup").popupContainerID + "'>"
					if (!$this.data("popup").closeButtonHide) popupTemplate = popupTemplate + "<a href='#' class='closeButton popupCloseButton'>" + $this.data("popup").closeButtonContent + "</a>"
					popupTemplate = popupTemplate + "<div id='popupContent'>" + popupContent + "</div>" +
										"</div>" +
									"</div>"
					//Add the popup to the page
					$("body").append(popupTemplate);
					//Position the popup in the middle of the screen and fade it in
					$("#" + $this.data("popup").overlayID).fadeIn("slow");
					//Call the callback function
					if (typeof $this.data("popup").buildCallback == 'function') $this.data("popup").buildCallback.call(this);
				}
				
				//If the popup is set to show instantly rather than on click
				if ($this.data("popup").instantShow) {
					showPopup();
				} else {
					//When the elements which involked the jQuery object is clicked on
					$this.click(function() {
						showPopup();
						//Return false to stop the link from following the destination URL
						return false;
					});
				}
		
				//Return this to maintain chainability (i.e. $(".popupLink").popup().css('color', 'red');)
				return this;
			});	
 		}
	};

	//Method calling logic
	$.fn.popup = function(method) {
		//If a method was specified
		if (methods[method]) {
			//Return the method
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		//If a method was not specified
		} else if (typeof method === "object" || !method) {
			//Return the init method
			return methods.init.apply(this, arguments);
		//If a method that does not exist was specified
		} else {
			//Write the error to the error log
			$.error("Method '" + method + "' does not exist on popup");
		}    
	};
})(jQuery);


    /*!
    * jQuery blockUI plugin
    * Version 2.39 (23-MAY-2011)
    * @requires jQuery v1.2.3 or later
    *
    * Examples at: http://malsup.com/jquery/block/
    * Copyright (c) 2007-2010 M. Alsup
    * Dual licensed under the MIT and GPL licenses:
    * http://www.opensource.org/licenses/mit-license.php
    * http://www.gnu.org/licenses/gpl.html
    *
    * Thanks to Amir-Hossein Sobhi for some excellent contributions!
    */

    ;(function($) {

        if (/1\.(0|1|2)\.(0|1|2)/.test($.fn.jquery) || /^1.1/.test($.fn.jquery)) {
            alert('blockUI requires jQuery v1.2.3 or later!  You are using v' + $.fn.jquery);
            return;
        }
        
        $.fn._fadeIn = $.fn.fadeIn;
        
        var noOp = function() {};
        
        // this bit is to ensure we don't call setExpression when we shouldn't (with extra muscle to handle
        // retarded userAgent strings on Vista)
        var mode = document.documentMode || 0;
        var setExpr = $.browser.msie && (($.browser.version < 8 && !mode) || mode < 8);
        var ie6 = $.browser.msie && /MSIE 6.0/.test(navigator.userAgent) && !mode;
        
        // global $ methods for blocking/unblocking the entire page
        $.blockUI   = function(opts) { install(window, opts); };
        $.unblockUI = function(opts) { remove(window, opts); };
        
        // convenience method for quick growl-like notifications  (http://www.google.com/search?q=growl)
        $.growlUI = function(title, message, timeout, onClose) {
            var $m = $('<div class="growlUI"></div>');
            if (title) $m.append('<h1>'+title+'</h1>');
            if (message) $m.append('<h2>'+message+'</h2>');
            if (timeout == undefined) timeout = 3000;
            $.blockUI({
                message: $m, fadeIn: 700, fadeOut: 1000, centerY: false,
                timeout: timeout, showOverlay: false,
                onUnblock: onClose, 
                css: $.blockUI.defaults.growlCSS
            });
        };
        
        // plugin method for blocking element content
        $.fn.block = function(opts) {
            return this.unblock({ fadeOut: 0 }).each(function() {
                if ($.css(this,'position') == 'static')
                    this.style.position = 'relative';
                if ($.browser.msie)
                    this.style.zoom = 1; // force 'hasLayout'
                install(this, opts);
            });
        };
        
        // plugin method for unblocking element content
        $.fn.unblock = function(opts) {
            return this.each(function() {
                remove(this, opts);
            });
        
        
        };
        
        $.blockUI.version = 2.39; // 2nd generation blocking at no extra cost!
        
        // override these in your code to change the default behavior and style
        $.blockUI.defaults = {
            // message displayed when blocking (use null for no message)
            message:  '<h1>Please wait...</h1>',
        
            title: null,	  // title string; only used when theme == true
            draggable: true,  // only used when theme == true (requires jquery-ui.js to be loaded)
            
            theme: false, // set to true to use with jQuery UI themes
            
            // styles for the message when blocking; if you wish to disable
            // these and use an external stylesheet then do this in your code:
            // $.blockUI.defaults.css = {};
            css: {
                padding:	0,
                margin:		0,
                width:		'30%',
                top:		'40%',
                left:		'35%',
                textAlign:	'center',
                color:		'#000',
                border:		'3px solid #aaa',
                backgroundColor:'#fff',
        
        
                cursor:		'wait'
            },
            
            // minimal style set used when themes are used
            themedCSS: {
                width:	'30%',
                top:	'40%',
                left:	'35%'
            },
        
            // styles for the overlay
            overlayCSS:  {
                backgroundColor: '#FFF',
                opacity:	  	 0.6,
                cursor:		  	 'wait'
            },
        
            // styles applied when using $.growlUI
            growlCSS: {
                width:  	'350px',
                top:		'10px',
                left:   	'',
                right:  	'10px',
                border: 	'none',
                padding:	'5px',
                opacity:	0.6,
                cursor: 	'default',
                color:		'#fff',
                backgroundColor: '#000',
                '-webkit-border-radius': '10px',
                '-moz-border-radius':	 '10px',
                'border-radius': 		 '10px'
            },
            
            // IE issues: 'about:blank' fails on HTTPS and javascript:false is s-l-o-w
            // (hat tip to Jorge H. N. de Vasconcelos)
            iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank',
        
            // force usage of iframe in non-IE browsers (handy for blocking applets)
            forceIframe: false,
        
            // z-index for the blocking overlay
            baseZ: 1000,
        
            // set these to true to have the message automatically centered
            centerX: true, // <-- only effects element blocking (page block controlled via css above)
            centerY: true,
        
            // allow body element to be stetched in ie6; this makes blocking look better
            // on "short" pages.  disable if you wish to prevent changes to the body height
            allowBodyStretch: true,
        
            // enable if you want key and mouse events to be disabled for content that is blocked
            bindEvents: true,
        
            // be default blockUI will supress tab navigation from leaving blocking content
            // (if bindEvents is true)
            constrainTabKey: true,
        
            // fadeIn time in millis; set to 0 to disable fadeIn on block
            fadeIn:  200,
        
            // fadeOut time in millis; set to 0 to disable fadeOut on unblock
            fadeOut:  400,
        
            // time in millis to wait before auto-unblocking; set to 0 to disable auto-unblock
            timeout: 0,
        
            // disable if you don't want to show the overlay
            showOverlay: true,
        
            // if true, focus will be placed in the first available input field when
            // page blocking
            focusInput: true,
        
            // suppresses the use of overlay styles on FF/Linux (due to performance issues with opacity)
            applyPlatformOpacityRules: true,
            
            // callback method invoked when fadeIn has completed and blocking message is visible
            onBlock: null,
        
            // callback method invoked when unblocking has completed; the callback is
            // passed the element that has been unblocked (which is the window object for page
            // blocks) and the options that were passed to the unblock call:
            //	 onUnblock(element, options)
            onUnblock: null,
        
            // don't ask; if you really must know: http://groups.google.com/group/jquery-en/browse_thread/thread/36640a8730503595/2f6a79a77a78e493#2f6a79a77a78e493
            quirksmodeOffsetHack: 4,
        
            // class name of the message block
            blockMsgClass: 'blockMsg'
        };
        
        // private data and functions follow...
        
        var pageBlock = null;
        var pageBlockEls = [];
        
        function install(el, opts) {
            var full = (el == window);
            var msg = opts && opts.message !== undefined ? opts.message : undefined;
            opts = $.extend({}, $.blockUI.defaults, opts || {});
            opts.overlayCSS = $.extend({}, $.blockUI.defaults.overlayCSS, opts.overlayCSS || {});
            var css = $.extend({}, $.blockUI.defaults.css, opts.css || {});
            var themedCSS = $.extend({}, $.blockUI.defaults.themedCSS, opts.themedCSS || {});
            msg = msg === undefined ? opts.message : msg;
        
            // remove the current block (if there is one)
            if (full && pageBlock)
                remove(window, {fadeOut:0});
        
            // if an existing element is being used as the blocking content then we capture
            // its current place in the DOM (and current display style) so we can restore
            // it when we unblock
            if (msg && typeof msg != 'string' && (msg.parentNode || msg.jquery)) {
                var node = msg.jquery ? msg[0] : msg;
                var data = {};
                $(el).data('blockUI.history', data);
                data.el = node;
                data.parent = node.parentNode;
                data.display = node.style.display;
                data.position = node.style.position;
                if (data.parent)
                    data.parent.removeChild(node);
            }
        
            $(el).data('blockUI.onUnblock', opts.onUnblock);
            var z = opts.baseZ;
        
            // blockUI uses 3 layers for blocking, for simplicity they are all used on every platform;
            // layer1 is the iframe layer which is used to supress bleed through of underlying content
            // layer2 is the overlay layer which has opacity and a wait cursor (by default)
            // layer3 is the message content that is displayed while blocking
        
            var lyr1 = ($.browser.msie || opts.forceIframe) 
                ? $('<iframe class="blockUI" style="z-index:'+ (z++) +';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="'+opts.iframeSrc+'"></iframe>')
                : $('<div class="blockUI" style="display:none"></div>');
            
            var lyr2 = opts.theme 
                ? $('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:'+ (z++) +';display:none"></div>')
                : $('<div class="blockUI blockOverlay" style="z-index:'+ (z++) +';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>');
        
            var lyr3, s;
            if (opts.theme && full) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:'+(z+10)+';display:none;position:fixed">' +
                        '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">'+(opts.title || '&nbsp;')+'</div>' +
                        '<div class="ui-widget-content ui-dialog-content"></div>' +
                    '</div>';
            }
            else if (opts.theme) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:'+(z+10)+';display:none;position:absolute">' +
                        '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">'+(opts.title || '&nbsp;')+'</div>' +
                        '<div class="ui-widget-content ui-dialog-content"></div>' +
                    '</div>';
            }
            else if (full) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage" style="z-index:'+(z+10)+';display:none;position:fixed"></div>';
            }			 
            else {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement" style="z-index:'+(z+10)+';display:none;position:absolute"></div>';
            }
            lyr3 = $(s);
        
            // if we have a message, style it
            if (msg) {
                if (opts.theme) {
                    lyr3.css(themedCSS);
                    lyr3.addClass('ui-widget-content');
                }
                else 
                    lyr3.css(css);
            }
        
            // style the overlay
            if (!opts.theme && (!opts.applyPlatformOpacityRules || !($.browser.mozilla && /Linux/.test(navigator.platform))))
                lyr2.css(opts.overlayCSS);
            lyr2.css('position', full ? 'fixed' : 'absolute');
        
            // make iframe layer transparent in IE
            if ($.browser.msie || opts.forceIframe)
                lyr1.css('opacity',0.0);
        
            //$([lyr1[0],lyr2[0],lyr3[0]]).appendTo(full ? 'body' : el);
            var layers = [lyr1,lyr2,lyr3], $par = full ? $('body') : $(el);
            $.each(layers, function() {
                this.appendTo($par);
            });
            
            if (opts.theme && opts.draggable && $.fn.draggable) {
                lyr3.draggable({
                    handle: '.ui-dialog-titlebar',
                    cancel: 'li'
                });
            }
        
            // ie7 must use absolute positioning in quirks mode and to account for activex issues (when scrolling)
            var expr = setExpr && (!$.boxModel || $('object,embed', full ? null : el).length > 0);
            if (ie6 || expr) {
                // give body 100% height
                if (full && opts.allowBodyStretch && $.boxModel)
                    $('html,body').css('height','100%');
        
                // fix ie6 issue when blocked element has a border width
                if ((ie6 || !$.boxModel) && !full) {
                    var t = sz(el,'borderTopWidth'), l = sz(el,'borderLeftWidth');
                    var fixT = t ? '(0 - '+t+')' : 0;
                    var fixL = l ? '(0 - '+l+')' : 0;
                }
        
                // simulate fixed position
                $.each([lyr1,lyr2,lyr3], function(i,o) {
                    var s = o[0].style;
                    s.position = 'absolute';
                    if (i < 2) {
                        full ? s.setExpression('height','Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.boxModel?0:'+opts.quirksmodeOffsetHack+') + "px"')
                            : s.setExpression('height','this.parentNode.offsetHeight + "px"');
                        full ? s.setExpression('width','jQuery.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"')
                            : s.setExpression('width','this.parentNode.offsetWidth + "px"');
                        if (fixL) s.setExpression('left', fixL);
                        if (fixT) s.setExpression('top', fixT);
                    }
                    else if (opts.centerY) {
                        if (full) s.setExpression('top','(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"');
                        s.marginTop = 0;
                    }
                    else if (!opts.centerY && full) {
                        var top = (opts.css && opts.css.top) ? parseInt(opts.css.top) : 0;
                        var expression = '((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + '+top+') + "px"';
                        s.setExpression('top',expression);
                    }
                });
            }
        
            // show the message
        
            if (msg) {
                if (opts.theme)
                    lyr3.find('.ui-widget-content').append(msg);
                else
                    lyr3.append(msg);
                if (msg.jquery || msg.nodeType)
                    $(msg).show();
            }
        
            if (($.browser.msie || opts.forceIframe) && opts.showOverlay)
                lyr1.show(); // opacity is zero
            if (opts.fadeIn) {
                var cb = opts.onBlock ? opts.onBlock : noOp;
                var cb1 = (opts.showOverlay && !msg) ? cb : noOp;
                var cb2 = msg ? cb : noOp;
                if (opts.showOverlay)
                    lyr2._fadeIn(opts.fadeIn, cb1);
                if (msg)
                    lyr3._fadeIn(opts.fadeIn, cb2);
            }
            else {
                if (opts.showOverlay)
                    lyr2.show();
                if (msg)
                    lyr3.show();
                if (opts.onBlock)
                    opts.onBlock();
            }
        
            // bind key and mouse events
            bind(1, el, opts);
        
            if (full) {
                pageBlock = lyr3[0];
                pageBlockEls = $(':input:enabled:visible',pageBlock);
                if (opts.focusInput)
                    setTimeout(focus, 20);
            }
            else
                center(lyr3[0], opts.centerX, opts.centerY);
        
            if (opts.timeout) {
                // auto-unblock
                var to = setTimeout(function() {
                    full ? $.unblockUI(opts) : $(el).unblock(opts);
                }, opts.timeout);
                $(el).data('blockUI.timeout', to);
            }
        };
        
        // remove the block
        function remove(el, opts) {
            var full = (el == window);
            var $el = $(el);
            var data = $el.data('blockUI.history');
            var to = $el.data('blockUI.timeout');
            if (to) {
                clearTimeout(to);
                $el.removeData('blockUI.timeout');
            }
            opts = $.extend({}, $.blockUI.defaults, opts || {});
            bind(0, el, opts); // unbind events
        
            if (opts.onUnblock === null) {
                opts.onUnblock = $el.data('blockUI.onUnblock');
                $el.removeData('blockUI.onUnblock');
            }
        
            var els;
            if (full) // crazy selector to handle odd field errors in ie6/7
                els = $('body').children().filter('.blockUI').add('body > .blockUI');
            else
                els = $('.blockUI', el);
        
            if (full)
                pageBlock = pageBlockEls = null;
        
            if (opts.fadeOut) {
                els.fadeOut(opts.fadeOut);
                setTimeout(function() { reset(els,data,opts,el); }, opts.fadeOut);
            }
            else
                reset(els, data, opts, el);
        };
        
        // move blocking element back into the DOM where it started
        function reset(els,data,opts,el) {
            els.each(function(i,o) {
                // remove via DOM calls so we don't lose event handlers
                if (this.parentNode)
                    this.parentNode.removeChild(this);
            });
        
            if (data && data.el) {
                data.el.style.display = data.display;
                data.el.style.position = data.position;
                if (data.parent)
                    data.parent.appendChild(data.el);
                $(el).removeData('blockUI.history');
            }
        
            if (typeof opts.onUnblock == 'function')
                opts.onUnblock(el,opts);
        };
        
        // bind/unbind the handler
        function bind(b, el, opts) {
            var full = el == window, $el = $(el);
        
            // don't bother unbinding if there is nothing to unbind
            if (!b && (full && !pageBlock || !full && !$el.data('blockUI.isBlocked')))
                return;
            if (!full)
                $el.data('blockUI.isBlocked', b);
        
            // don't bind events when overlay is not in use or if bindEvents is false
            if (!opts.bindEvents || (b && !opts.showOverlay)) 
                return;
        
            // bind anchors and inputs for mouse and key events
            var events = 'mousedown mouseup keydown keypress';
            b ? $(document).bind(events, opts, handler) : $(document).unbind(events, handler);
        
        // former impl...
        //	   var $e = $('a,:input');
        //	   b ? $e.bind(events, opts, handler) : $e.unbind(events, handler);
        };
        
        // event handler to suppress keyboard/mouse events when blocking
        function handler(e) {
            // allow tab navigation (conditionally)
            if (e.keyCode && e.keyCode == 9) {
                if (pageBlock && e.data.constrainTabKey) {
                    var els = pageBlockEls;
                    var fwd = !e.shiftKey && e.target === els[els.length-1];
                    var back = e.shiftKey && e.target === els[0];
                    if (fwd || back) {
                        setTimeout(function(){focus(back)},10);
                        return false;
                    }
                }
            }
            var opts = e.data;
            // allow events within the message content
            if ($(e.target).parents('div.' + opts.blockMsgClass).length > 0)
                return true;
        
            // allow events for content that is not being blocked
            return $(e.target).parents().children().filter('div.blockUI').length == 0;
        };
        
        function focus(back) {
            if (!pageBlockEls)
                return;
            var e = pageBlockEls[back===true ? pageBlockEls.length-1 : 0];
            if (e)
                e.focus();
        };
        
        function center(el, x, y) {
            var p = el.parentNode, s = el.style;
            var l = ((p.offsetWidth - el.offsetWidth)/2) - sz(p,'borderLeftWidth');
            var t = ((p.offsetHeight - el.offsetHeight)/2) - sz(p,'borderTopWidth');
            if (x) s.left = l > 0 ? (l+'px') : '0';
            if (y) s.top  = t > 0 ? (t+'px') : '0';
        };
        
        function sz(el, p) {
            return parseInt($.css(el,p))||0;
        };
        
        })(jQuery);

/********************************************************************************************************/
	/****************************************New password checking ******************************************/
	/********************************************************************************************************/
	

	// if ($("#checkoutForm").length) {

    //     $("#hasPassword, #saveDetails").hiddenAreas();

    //     $('body').on('change','#saveDetails', function() {
    //         if ($('#saveDetails').prop('checked')) {
    //             $("#newPassword, #confirmPassword").attr('disabled', false);
    //         } else {
    //             $("#newPassword, #confirmPassword").attr('disabled', true);
    //         }
    //     });


	// 	if (!$('#saveDetails').prop('checked')) {
	// 		$("#newPassword, #confirmPassword").attr('disabled', true);
	// 	}
	// }






    /********************************************************************************************************/
    /****************************************Delivery zone checking******************************************/
    /********************************************************************************************************/	
    /*Run this function when the page loads*/
    $(document).ready(function(){						
        //Get the postcode to be checked depending on the checkoutDelivery value
        var $deliveryUpgradeContainer = $("#deliveryUpgradeContainer");
        var $checkoutSummaryBasket = $("#basket-summary");	
        var requestTimer, postRequest;
        // Is the checkout in paypal mode if so then pass parameter to get the correct continue button text.
        let paypal = ($deliveryUpgradeContainer.attr('data-paypal-checkout') != undefined);
        // Check delivery zone onload.
        let checkDelZoneOnload = ($deliveryUpgradeContainer.attr('data-check-delivery-onload') != undefined);
        if ($("#checkout-content-container").length && checkDelZoneOnload) {
            deliveryUpdateShim();
        }

        function deliveryUpdateShim(context) {

            var addressToCheck, deliveryUpdateCountry, deliveryUpdateCountryCode, deliveryUpdatePostcode;
            addressToCheck = $("#delivery").is(":checked") ? "delivery" : "bill";
            // If the checkbox has been suppressed.
            if ($('#delivery').length > 0 && $("#delivery").attr("type") != "checkbox") {
                addressToCheck = "delivery";
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Checkout: Delivery address checkbox suppressed there for checking the following address: " + addressToCheck);
                }
            }
            deliveryUpdateCountry = "#" + addressToCheck + "Country";
            if (context === "delivery_country") {
                deliveryUpdateCountryCode = "#" + context;
            } else if ($(this).attr("id") === addressToCheck + "PostcodeLookupSelect") {
                deliveryUpdatePostcode = "#" + addressToCheck + "PostcodeLookup";
            } else {
                deliveryUpdatePostcode = "#" + addressToCheck + "Postcode";
            }
            deliveryUpdate(deliveryUpdatePostcode, deliveryUpdateCountry, deliveryUpdateCountryCode, addressToCheck);
        }
        
        function deliveryUpdate(postcodeInput, countryInput, countryCodeInput, addressToCheck) {
            var deliveryPostcodeValue = $.trim($(postcodeInput).val());
            var deliveryCountryValue = $.trim($(countryInput).val());
            var deliveryCountryCodeValue = $.trim($(countryCodeInput).val());
            //If the last postcode checked is not the same as the postcode used this time
            if ((deliveryPostcodeValue.length && (($.data($deliveryUpgradeContainer).lastPostcodeValue != deliveryPostcodeValue) || ($.data($deliveryUpgradeContainer).lastCountryValue != deliveryCountryValue))) || (deliveryCountryCodeValue.length && ($.data($deliveryUpgradeContainer).lastCountryCodeValue != deliveryCountryCodeValue)) || (deliveryCountryValue.length && ($.data($deliveryUpgradeContainer).lastCountryValue != deliveryCountryValue)) || ((!deliveryPostcodeValue.length) && (deliveryCountryValue.length))) {
                //Attach this postcode to the delivery element
                $.data($deliveryUpgradeContainer, "lastPostcodeValue", deliveryPostcodeValue);
                //Attach this country to the delivery element
                $.data($deliveryUpgradeContainer, "lastCountryValue", deliveryCountryValue);
                //Attach this country code to the delivery element
                $.data($deliveryUpgradeContainer, "lastCountryCodeValue", deliveryCountryCodeValue);
                //If there is an existing request, abort it
                if (postRequest) { postRequest.abort() } 
                //Clear the timer to stop duplicates
                clearTimeout(requestTimer); 
                //Assign the timer a new timeout 
                requestTimer = setTimeout(function() {
                    //Load the layer mask to show that the page is working
                    $deliveryUpgradeContainer.block({message: null});
                    //$("#checkoutButtonContainer button").prop("disabled", "disabled");
                    $("#checkoutButtonContainer button").addClass('disabled');
                    var checkDelivery = false;
                    
                    //let initialiseCheckout = checkoutInitialise();

                    if ($("#delivery").prop('checked') == false) {
                        checkDelivery = false;
                        //Re-enable submission button.
                        $("#checkoutButtonContainer button").prop("disabled", false);
                        $("#checkoutButtonContainer button").removeClass('disabled');
                    } else {
                        checkDelivery = true;
                    }
                    
                    postRequest = $.post(siteRootCommon + "includes/deliveryUpgrade.asp", {postcode: deliveryPostcodeValue, countryCode: deliveryCountryCodeValue, country: deliveryCountryValue, action: "show", "check-delivery": checkDelivery, dynamicUpdate: true, "paypal": paypal}, function(deliveryOptions){
                        //If zone select form exists
                        $deliveryUpgradeContainer.html(deliveryOptions).unblock();

                        //let initialiseCheckout = checkoutInitialise();
                        // Get continue button context.
                        let continueButton = $("#checkoutButtonContainer button");
                        // Find delivery update container.
                        let deliveryContainer = $deliveryUpgradeContainer;
                        // Is delivery enabled? 
                        let deliveryEnabled = (deliveryContainer.length > 0 ? true : false);
                        // Find delivery input.
                        let deliveryInput = $deliveryUpgradeContainer.find('input[name="DelZone"]');

                        // If delivery is enabled.
                        if (deliveryEnabled) {
                            if (AXISDebug.level() >= 3) {
                                AXISDebug.output(1,"Checkout: Delivery is enabled so performing check on", deliveryInput);
                            }
                            // Check if valid delivery set.
                            if (deliveryInput.length >= 0 && deliveryInput.val() == 0) {
                                // continueButton.prop("disabled", true);
                                continueButton.addClass('disabled');
                                let reason = deliveryContainer.attr('data-delivery-error');
                                if (reason) {
                                    continueButton.attr('data-invalid-reason', reason);
                                }

                                if (AXISDebug.level() >= 3) {
                                    AXISDebug.output(1,"Checkout: Disabling continue button due to no delivery option selected.");
                                }

                            } else {
                                //continueButton.prop("disabled", false);
                                continueButton.removeClass('disabled');
                                if (continueButton.attr('data-invalid-reason')) {
                                    continueButton.removeAttr('data-invalid-reason');
                                }
                                if (AXISDebug.level() >= 3) {
                                    AXISDebug.output(1,"Checkout: Re-enabling the continue button as delivery zone input selected.");
                                }
                            }	
                        }

                        if (deliveryInput.length == 0 && deliveryEnabled) {
                            // Disabled checkout continue button.
                            continueButton.addClass('disabled');
                            // Initialise the inputs.
                            AXISInputs.initialiseControlInputs($("#deliveryUpgradeContainer .control"));
                            //Load the layer mask to show that the page is working
                            $checkoutSummaryBasket.block({message: null});
                            $.post(siteRootCommon + "includes/deliveryUpgrade.asp", {action: "update", dynamicUpdate: true, "paypal": paypal}, function(basketSummary){
                                $checkoutSummaryBasket.html(basketSummary).unblock();
                                //let initialiseCheckout = checkoutInitialise();
                                // In the situation where the postcode gets set after the update function ( normally on initial load ).
                                if (!deliveryPostcodeValue.trim() && !$("#" + addressToCheck + "PostcodeLookupSelect").val() == 0) {
                                    deliveryUpdate($("#deliveryPostcode"));
                                }
                            });
                        } else {
                            continueButton.removeClass('disabled');
                            //Load the layer mask to show that the page is working
                            $.post(siteRootCommon + "includes/deliveryUpgrade.asp", {delZone: $("input[name=DelZone]:checked").val(), action: "update", dynamicUpdate: true, "paypal": paypal}, function(basketSummary){
                                // Update markup.
                                $checkoutSummaryBasket.html(basketSummary);
                                // re-initialise checkout.
                                //let initialiseCheckout = checkoutInitialise();
                            });
                        }
                    });
                //The time to wait between requests
                }, 1000); 
            }
        }
        
        if ($deliveryUpgradeContainer.length) {
            $deliveryUpgradeContainer.on("click", "input[name=DelZone], .applyButton", function() {
                var deliveryZone = $("input[name=DelZone]:checked").val();
                var vatCode = $("input[name=basket_vat_code]").val();
                //Load the layer mask to show that the page is working
                $checkoutSummaryBasket.block({message: null});	
                //$("#checkoutButtonContainer button").prop("disabled", "disabled");
                $("#checkoutButtonContainer button").addClass('disabled');
                $.post(siteRootCommon + "includes/deliveryUpgrade.asp", {delZone: deliveryZone, action: "update", dynamicUpdate: true, basket_vat_code: vatCode, "paypal": paypal}, function(basketSummary){
                    $checkoutSummaryBasket.html(basketSummary).unblock();
                    //let initialiseCheckout = checkoutInitialise();
                    // Text for submit button.
                    var submitButtonText = $checkoutSummaryBasket.find('[data-checkout-button-text]').data('checkout-button-text');
                    if (submitButtonText) {
                        // Update submit button with text.
                        $("#checkoutButtonContainer button").text(submitButtonText);
                    }
                    // Re-enable submit button.
                    $("#checkoutButtonContainer button").prop("disabled", false);
                    $("#checkoutButtonContainer button").removeClass('disabled');
                });
                if ($(this).hasClass("applyButton")) return false;
            });
            
            $(document).ajaxComplete(function(event, xhr, settings) {
                if ((settings.url === "includes/postcodeLookup.asp") && (settings.data.indexOf("inputPrefix=delivery") != -1) && (settings.data.indexOf("postcodeLookupSelectInput") != -1)) {
                    deliveryUpdate($("#deliveryPostcode"));
                }
            });
            //Triggers the delivery update process on any modification or interaction, this is also used when the address lookup has a selected option.
            $("#checkout-content-container").on("keyup change", "#billPostcode, #deliveryPostcode, #billCountry, #deliveryCountry", function() {
                deliveryUpdateShim();
                
            });
            //Add listener only after the initial load to prevent a blank postback on initial activation.
            $("#checkout-content-container").on("change", "#delivery", function() {
                deliveryUpdateShim();
            });

            $("#checkout-content-container").on("change", "#delivery_country",function() {
                deliveryUpdateShim(this.id);
            });
            //Update the delivery details if the postcode lookup or previous address select changes value.
            $("#checkout-content-container").on("change", "#billPostcodeLookupSelect, #deliveryPostcodeLookupSelect, #deliveryPreviousAddressSelect", function() {
                //Adding timeout due to the AJAX post the delivery update was happening before the postcode lookup updates the input values. 
                setTimeout(function() { 
                    //Manually trigger the deliveryUpdateShim().
                    $("#billPostcode, #deliveryPostcode").trigger("change"); 
                },1000)
            });
            //Update delivery details on page if the basket checkbox has been suppressed.
            if ($('#delivery').length) {
                if ($('#delivery').hasClass('suppressedTrigger')) {
                    deliveryUpdateShim();
                    //Select the default title. (Made sense to put this here considering we are already doing the required checkes + its delivery related.)
                    var defaultDeliveryTitle = $('#deliveryTitle').attr('data-default-delivery-title');
                    //Check each option value against the default delivery title attribute, if a match is found then select the matched option and update the uniform plugin.
                    $('#deliveryTitle option').each(function() {
                        if ($(this).val() == defaultDeliveryTitle) {
                            $(this).attr("selected","selected");
                            // $.uniform.update();
                        }
                    });
                } else {
                    console.log("Delivery is active but not automatically displayed.")
                }
                
            }
        }
    });


    // ----- Delivery zone -----  
    //Get the checkout address form
    var $checkoutForm = $("#checkoutForm");

    $checkoutForm.submit(function () {
        if ($("#deliveryInvalid").length > 0) {
            alert("Invalid delivery address.");
            return false;
        }
    });

    // Only allow the form to submit once.
    $checkoutForm.on('submit', function() {
        // Submit button context.
        let submitButton = $('#checkoutButtonContainer button');
        // Disable submit button to prevent duplicate submissions.
        submitButton.attr('disabled', true);
        // Prevent validation from re-enabling this button due to validation check on submit, normally we don't need this as when we ajax you can only perform 1 request at a time per data-ajax instance but the checkout doesn't use the ajax.
        $checkoutForm.attr('form-is-submitting', '');
    });

    //Ensure that if the user presses return on the postcode input that the correct button is "clicked"
	$(".postcodeLookup").keypress(function(e) {
		var $this = $(this);
		if (e.keyCode == "13") {
			e.preventDefault();
			$this.parents(".postcodeLookupContainer").find(".postcodeLookupButton").trigger('click');
		}
	});
	//When the postcode lookup button is clicked
	$("body").on("click", ".postcodeLookupButton", function(){
		//The container surrounding the post code lookup
		var postcodeLookupContainer = $(this).parents(".postcodeLookupContainer");
		//Get the clases used on the container to apply them to the formfields generated by the asp page
		var postcodeLookupContainerClasses = postcodeLookupContainer.attr("class").replace("postcodeLookupContainer", "").replace("hide", "");
		//The postcode lookup text input
		var postcodeLookup = $(postcodeLookupContainer).find(".postcodeLookup");
		//The value entered into the postcode lookup input
		var postcodeLookupValue = postcodeLookup.prop("value");
		//The prefix that identifies the address being looked up
		var postcodeLookupPrefix = $(this).attr("name");
		//Set whether the prefix is used infront of the address fields when they are created
		var usePrefix = false
		//If there is more than one lookup container set the prefix to be used
		if ($(".postcodeLookupContainer").length > 1 || $(this).hasClass("usePrefix")) usePrefix = true
		//The parameters passed through (encode the postcode lookup classes in case there are multiple with spaces inbetween)
		var standardParams = "content=postcodeLookup&inputPrefix=" + postcodeLookupPrefix + "&usePrefix=" + usePrefix + "&formFieldClasses=" + encodeURI(postcodeLookupContainerClasses);
		//If no value has been entered
		if(postcodeLookupValue === ""){
			//Focus on the postcode lookup input
			$(postcodeLookup).focus();
			//Stop the form from being submitted
			return false;
		//If a value has been entered
		} else {
			//Load the layer mask to show that the page is working
			$(postcodeLookupContainer).block({message: null});

			//Use AJAX to get the postcode select box
			$.ajax({cache: false, data: standardParams + "&postcodeLookupInput=" + postcodeLookupValue + "&operation=find", dataType: "html", type: "POST", url: siteRootCommon + "includes/getSetContent.asp",
				//If a problem has occurred getting the select box
				error: function(){
					//Alert the user and remove the loading graphic from the lookup container
					alert("Sorry, we were unable to carry out a postcode lookup, please try again");
					$(postcodeLookupContainer).unblock();
				},
				//If the select box is returned
				success: function(selectBoxContent){
					//The select box offering a list of addresses matching the post code
					var postcodeLookupSelect = ("#" + postcodeLookupPrefix + "PostcodeLookupSelect");
					//The container around the select box
					var postcodeLookupSelectContainer = "#" + postcodeLookupPrefix + "PostcodeLookupSelectContainer";

					setTimeout(function(){
						//Remove the loading graphic from the lookup container
						$(postcodeLookupContainer).unblock();
						
						//If the address select box container already exists
						if($(postcodeLookupSelectContainer).length > 0){
							//Replace it with the new select box
							$(postcodeLookupSelectContainer).replaceWith(selectBoxContent);
						//If the address select box container does not exist
						} else {
							//Insert the select box after the postcode entry container
							$(postcodeLookupContainer).after(selectBoxContent);
						}
                        $("#" + postcodeLookupPrefix + "PostcodeLookupSelectContainer .control").each(function() {
                            let context = $(this);
                            AXISInputs.initialiseControlInputs(context);
                        });

                        $(deliveryFields).attr('required','');

						//If a single result has been found
						if ($("#" + postcodeLookupPrefix + "LookupSingle").length > 0){
							var addressSelectID = $("#" + postcodeLookupPrefix + "LookupSingle").prop("value");
	
							//Load the layer mask to show that the page is working
							$(postcodeLookupSelectContainer).block({message: null});
	
							//Use AJAX to get the address
							$.ajax({cache: false, data: standardParams + "&postcodeLookupSelectInput=" + addressSelectID, dataType: "html", type: "POST", url: siteRootCommon + "includes/getSetContent.asp",
								//If a problem has occurred getting the address alert the user and remove the loading graphic from the select container
								error: function(){
									alert("Sorry, an error occurred adding your selected address, please try again");
									$(postcodeLookupSelectContainer).unblock(); 
								},
								//If the address is returned replace the address fields with the address found by the lookup
								success: function(addressContent){
									$("#" + postcodeLookupPrefix + "PostcodeLookupAddressContainer").html(addressContent);
									$(postcodeLookupSelectContainer).hide();
									$(postcodeLookupSelectContainer).unblock(); 						
								}
							});
						} else {	
							//When a change occurs to the lookup select box. Apply uniform to the select box
							$(postcodeLookupSelect).bind("change", function(){
								var addressSelectID = $(this).prop("value");
	
								//Load the layer mask to show that the page is working
								$(postcodeLookupSelectContainer).block({message: null});
	
								//Use AJAX to get the address
								$.ajax({cache: false, data: standardParams + "&postcodeLookupSelectInput=" + addressSelectID + "&operation=return", dataType: "html", type: "POST", url: siteRootCommon + "includes/getSetContent.asp",
									//If a problem has occurred getting the address
									error: function(){
										//Alert the user and remove the loading graphic from the select container
										alert("Sorry, an error occurred adding your selected address, please try again");
										$(postcodeLookupSelectContainer).unblock();
									},
									//If the address is returned
									success: function(addressContent){
										//Replace the address fields with the address found by the lookup
                                        // TODO: Needs to use express control select initaliser.
										$("#" + postcodeLookupPrefix + "PostcodeLookupAddressContainer").html(addressContent);

                                        $("#" + postcodeLookupPrefix + "PostcodeLookupAddressContainer .control").each(function() {
                                            let context =$(this);
                                            AXISInputs.initialiseControlInputs(context);
                                        });

                                        AXISInputs.revalidate($('#checkoutForm'));
                                        // Bodge to force validation to work in express's manor.
                                        $(deliveryFields).attr('required','');

										$(postcodeLookupSelectContainer).unblock();
									}
								});
							});
						}
					}, 500);
				}
			});
		}
		return false;
	});
	
	//When the previous address select boxes are changed
	$("select.previousAddressSelect").bind("change", function(){
		var $this = $(this);
		var addressSelectID = $this.prop("value");
		//The container surrounding the previous address lookup
		var $previousAddressContainer = $this.parents(".previousAddressSelectContainer");
		//Get the clases used on the container to apply them to the formfields generated by the asp page
		var previousAddressContainerClasses = $previousAddressContainer.attr("class").replace("previousAddressSelectContainer", "").replace("hide", "");
		//The prefix that identifies the address being looked up
		var previousAddressPrefix = $this.attr("name").replace("PreviousAddressSelect", "");
		//Set whether the prefix is used infront of the address fields when they are created
		var usePrefix = false;
		if (previousAddressPrefix.length > 1) { usePrefix = true	}
		//The parameters passed through (encode the classes in case there are multiple with spaces inbetween)
		var standardParams = "content=postcodeLookup&inputPrefix=" + previousAddressPrefix + "&usePrefix=" + usePrefix + "&formFieldClasses=" + encodeURI(previousAddressContainerClasses);
		
		//Load the layer mask to show that the page is working
		$previousAddressContainer.block({message: null});
		
		//Use AJAX to get the address
		$.ajax({cache: false, data: standardParams + "&postcodeLookupSelectInput=" + addressSelectID + "&previousAddress=true&operation=return", dataType: "html", type: "post", url: siteRootCommon + "includes/getSetContent.asp",
			//If a problem has occurred getting the address alert the user and remove the loading graphic from the select container
			error: function(){
				alert("Sorry, an error occurred adding your selected address, please try again");
				$previousAddressContainer.unblock(); 
			},
			//If the address is returned replace the address fields with the address found by the lookup
			success: function(addressContent){
				$("#" + previousAddressPrefix + "PostcodeLookupAddressContainer").html(addressContent);
                

                $("#" + previousAddressPrefix + "PostcodeLookupAddressContainer .control.undefined").each(function() {
                    let context = $(this);
                    AXISInputs.initialiseControlInputs(context);
                });

                AXISInputs.revalidate($('#checkoutForm'));

                $previousAddressContainer.unblock(); 						
			}
		});
	});



    $(".popupLink, .checkoutPopupLink").popup({
		buildCallback: function() {
			//$("#popupContent select:not([multiple]), #popupContent input[type=checkbox], #popupContent input[type=radio]").uniform();
            $("#popupContent .control").each(function() {
                let context = $(this);
                AXISInputs.initialiseControlInputs(context);
            });
            

		},
		closeButtonContent: "",
		includeURL: siteRootCommon + "includes/getSetContent.asp",
		popupContainerClass: "scroll"
	});	

    //When the change contact form is submitted in a popup
	$("body").on("submit", "#popupContent #change-contact-details", function() {
		//Can't find a way to make the validation rules work with the AJAX form unless they are specified here
		$("#change-contact-details").validate({
			rules: {
				accountForename: {
					required: true,
					maxlength: 20
				},
				accountSurname: {
					required: true,
					maxlength: 20
				},
				accountTelephone: {
					required: true,
					minlength: 6,
					maxlength: 20
				},
				accountMobile: {
					minlength: 6,
					maxlength: 20
				}
			},
			messages: {
				accountTelephone: {
					required: "Please enter a valid telephone number.",
					minlength: "Please enter a valid telephone number."
				},
				accountMobile: {
					minlength: "Please enter a valid telephone number."
				}
			}
		});	

		//If the inputs are valid
		if ($("#change-contact-details").valid()) {
			//Use AJAX to update and display the new details
			$.ajax({ type: "POST", url: siteRootCommon + "includes/getSetContent.asp", data: "operation=set&content=popups&popupID=edit-contact-details&" + $("#change-contact-details").serialize(), cache: false, success: function(popupContent, status, request){
				//Fade out the old data
				$("#popupContent").fadeOut("fast", function(){
					//Load and fade in the new data
					$(this).html(popupContent).fadeIn();

                    

                    $(this).find('.control').each(function() {
                        // Get context.
                        let input = $(this);
                        // Initialise.
                        let init = AXISInputs.initialiseControlInputs(input);
                    });

					//Reapply the uniform styles
					//$("#popupContent select:not([multiple]), #popupContent input[type=checkbox], #popupContent input[type=radio]").uniform();
					//Use AJAX to update the customer details on the page
					$.ajax({ type: "POST", url: siteRootCommon + "includes/getSetContent.asp", dataType: "json", data: {operation: "get", content: "replacements", replacementID: "accountDetails"}, cache: false, success: function(replacementContent, status, request){
                        $("#title").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('select')) {
                                context.val(replacementContent.title).trigger("change");
                            } else {
                                context.html(replacementContent.title);
                            }
                            context.fadeIn();
                        });
						$("#forename").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('input')) {
                                context.val(replacementContent.forename);
                            } else {
                                context.html(replacementContent.forename);
                            }
                            context.fadeIn();
                        });
						$("#surname").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('input')) {
                                context.val(replacementContent.surname);
                            } else  {
                                context.html(replacementContent.surname);
                            }
                            context.fadeIn();
                            
                        });
                        $("#email").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('input')) {
                                context.val(replacementContent.email);
                            } else  {
                                context.html(replacementContent.email);
                            }
                            context.fadeIn();
                            
                        });
						$("#telephone").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('input')) {
                                context.val(replacementContent.telephone);
                            } else {
                                context.html(replacementContent.telephone);
                            }
                            context.fadeIn();
                        });
						$("#mobile").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('input')) {
                                context.val(replacementContent.mobile);
                            } else {
                                context.html(replacementContent.mobile);
                            }
                            context.fadeIn();
                            
                        });
                        $("#invoiceAddress").fadeOut("slow", function(){
                            $(this).html(replacementContent.address).fadeIn()
                        });
					}});				
				});
			}});
		}
		return false;
	});

    //When the change billing address form is submitted in a popup
	$("body").on("submit", "#popupContent #edit-billing-address", function() {
		//Can't find a way to make the validation rules work with the AJAX form unless they are specified here
		$("#edit-billing-address").validate({
			rules: {
				accountOrganisation: {
					maxlength: 30
				},
				accountAddress1: {
					required: true,
					maxlength: 30
				},
				accountAddress2: {
					maxlength: 30
				},
				accountTown: {
					required: true,
					maxlength: 30
				},
				accountCounty: {
					maxlength: 30
				},
				accountPostcode: {
					required: true,
					maxlength: 30
				}
			}
		});	

		//If the inputs are valid
		if ($("#edit-billing-address").valid()) {
			//Use AJAX to update and display the new details
			$.ajax({ type: "POST", url: siteRootCommon + "includes/getSetContent.asp", data: "operation=set&content=popups&popupID=edit-billing-address&" + $("#edit-billing-address").serialize(), cache: false, success: function(popupContent, status, request){
				//Fade out the old data
				$("#popupContent").fadeOut("fast", function(){
					//Load and fade in the new data
					$(this).html(popupContent).fadeIn();
                    // Re-initialise inputs.
                    $(this).find('.control').each(function() {
                        // Get context.
                        let input = $(this);
                        // Initialise.
                        let init = AXISInputs.initialiseControlInputs(input);
                    });

					//Reapply the uniform styles
					//$("#popupContent select:not([multiple]), #popupContent input[type=checkbox], #popupContent input[type=radio]").uniform();
					//Use AJAX to update the customer details on the page
					$.ajax({ type: "POST", url: siteRootCommon + "includes/getSetContent.asp", dataType: "json", data: {operation: "get", content: "replacements", replacementID: "accountDetails"}, cache: false, success: function(replacementContent, status, request){
						$("#invoiceAddress").fadeOut("slow", function(){
                            $(this).html(replacementContent.address).fadeIn()
                        });
					}});				
				});
			}});
		}
		return false;
	});

    //When the change details form is submitted in a popup
	$("body").on("submit", "#popupContent #changeDetailsForm", function() {
		//Can't find a way to make the validation rules work with the AJAX form unless they are specified here
		$("#changeDetailsForm").validate({
			rules: {
				accountForename: {
					required: true,
					maxlength: 20
				},
				accountSurname: {
					required: true,
					maxlength: 20
				},
				accountOrganisation: {
					maxlength: 30
				},
				accountAddress1: {
					required: true,
					maxlength: 30
				},
				accountAddress2: {
					maxlength: 30
				},
				accountTown: {
					required: true,
					maxlength: 30
				},
				accountCounty: {
					maxlength: 30
				},
				accountPostcode: {
					required: true,
					maxlength: 30
				},
				accountTelephone: {
					required: true,
					minlength: 6,
					maxlength: 20
				},
				accountMobile: {
					minlength: 6,
					maxlength: 20
				}
			},
			messages: {
				accountTelephone: {
					required: "Please enter a valid telephone number.",
					minlength: "Please enter a valid telephone number."
				},
				accountMobile: {
					minlength: "Please enter a valid telephone number."
				}
			}
		});	

		//If the inputs are valid
		if ($("#changeDetailsForm").valid()) {
			//Use AJAX to update and display the new details
			$.ajax({ type: "POST", url: siteRootCommon + "includes/getSetContent.asp", data: "operation=set&content=popups&popupID=editAccountDetails&" + $("#changeDetailsForm").serialize(), cache: false, success: function(popupContent, status, request){
				//Fade out the old data
				$("#popupContent").fadeOut("fast", function(){
					//Load and fade in the new data
					$(this).html(popupContent).fadeIn();
					//Reapply the uniform styles
					//$("#popupContent select:not([multiple]), #popupContent input[type=checkbox], #popupContent input[type=radio]").uniform();
					//Use AJAX to update the customer details on the page
					$.ajax({ type: "POST", url: siteRootCommon + "includes/getSetContent.asp", dataType: "json", data: {operation: "get", content: "replacements", replacementID: "accountDetails"}, cache: false, success: function(replacementContent, status, request){
                        $("#title").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('select')) {
                                context.val(replacementContent.title).trigger("change");
                            } else {
                                context.html(replacementContent.title);
                            }
                            context.fadeIn();
                        });
						$("#forename").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('input')) {
                                context.val(replacementContent.forename);
                            } else {
                                context.html(replacementContent.forename);
                            }
                            context.fadeIn();
                        });
						$("#surname").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('input')) {
                                context.val(replacementContent.surname);
                            } else  {
                                context.html(replacementContent.surname);
                            }
                            context.fadeIn();
                            
                        });
                        $("#email").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('input')) {
                                context.val(replacementContent.email);
                            } else  {
                                context.html(replacementContent.email);
                            }
                            context.fadeIn();
                            
                        });
						$("#telephone").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('input')) {
                                context.val(replacementContent.telephone);
                            } else {
                                context.html(replacementContent.telephone);
                            }
                            context.fadeIn();
                        });
						$("#mobile").fadeOut("slow", function(){
                            let context = $(this);
                            if (context.is('input')) {
                                context.val(replacementContent.mobile);
                            } else {
                                context.html(replacementContent.mobile);
                            }
                            context.fadeIn();
                            
                        });
						$("#invoiceAddress").fadeOut("slow", function(){
                            $(this).html(replacementContent.address).fadeIn()
                        });
						$("#billPostcode").val(replacementContent.postcode).trigger("change");
						$("#billCountry").val(replacementContent.country).trigger("change");
					}});				
				});
			}});
		}
		return false;
	});

    $("#delivery").hiddenAreas();

    // Not the best solution but fastest way to integrate into the new JS validation.
    let deliveryFields = "#deliveryForename, #deliverySurname, #deliveryAddress1, #deliveryTown, #deliveryPostcode, #deliveryContactEmail, #deliveryContactMobile";


    if ($('#delivery').length > 0) {
        if (!$('#delivery').is(':checked') && !$('#delivery').hasClass('suppressedTrigger')) {
            $(deliveryFields).attr('data-abide-ignore', '');
        }
    }
    

    $('#delivery').on('change', function() {
        let context = $(this);
        if (context.prop('checked')) {
            $(deliveryFields).removeAttr('data-abide-ignore');
            // Don't do this due as the delivery contact email & mobile requirement can be configured by the server.
            //$(deliveryFields).attr('required', '');
        } else {
            $(deliveryFields).attr('data-abide-ignore', '');
        }
    });

    // Check whether continue button is disabled if so then output message.
    $('#checkoutButtonContainer button').on('click', function(event) {
        event.preventDefault();
        let context = $(this);
        let isButtonDisabled = AXISInputs.disabledButtons(context);
        if (!isButtonDisabled) {
            context.parents('form').submit();
        } else {
            return false;
        }
    });
}


